import { render } from "./kouqiang-news.vue?vue&type=template&id=11bf797a&scoped=true"
import script from "./kouqiang-news.vue?vue&type=script&lang=js"
export * from "./kouqiang-news.vue?vue&type=script&lang=js"

import "./kouqiang-news.vue?vue&type=style&index=0&id=11bf797a&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11bf797a"]])

export default __exports__